
export const ALL_VARIANTS = [
    "2179388",
    "2139863",
    "1985477",
    "1579390"
];